import { invariant } from './invariant';

export type FourValueTuple<T> = [T, T, T, T];

export type FourValueTupleConvertable<T> =
  | T
  | [T]
  | [T, T]
  | [T, T, T]
  | FourValueTuple<T>;

export function to4VTuple<T>(input: FourValueTupleConvertable<T>) {
  if (!Array.isArray(input)) {
    return Array(4).fill(input) as FourValueTuple<T>;
  }

  const { length } = input;

  invariant(
    length > 0 && length < 5,
    'Expected the input to be from 1 till 4 values long.'
  );

  const top = input[0];
  const right = length > 1 ? input[1] : top;
  const bottom = length > 2 ? input[2] : top;
  const left = length === 4 ? input[3] : right;

  return [top, right, bottom, left] as FourValueTuple<T>;
}
